













































































































































import { Component, Watch, Prop } from 'vue-property-decorator'
import { post } from '@/fn/ajax'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { alert, success, confirm } from '@/util/modal'
import Header from '@/components/header'
import PlayClassModal from './playClassModal.vue'
import Confirm from './../admin/confirm.vue'
import {
  PlayClassList,
  PlayItem,
  PlayClass,
  PlayDeviceList,
  PlayInstall,
  StudyData
} from '@/components/playClass'
import { courseItem, resourceItem } from '@/api/res'
import { message } from 'ant-design-vue'

@Component({
  components: {
    PlayClassList,
    PlayItem,
    PlayClass,
    PlayDeviceList,
    PlayInstall,
    StudyData,
    Header,
    PlayClassModal,
    Confirm
  }
})
export default class PlayIndex extends ViewBase {
  lang: any = {}

  id: any = this.$store.state.playId

  item: any = {}

  chapter: any = []

  chapterList: any = []

  playStatus: string = 'Play'

  reloadPlay: boolean = true

  classActive: boolean = false

  installActive: boolean = false

  dataActive: boolean = false

  playChanged: boolean = false

  visible: boolean = true

  choiceClass: boolean = false

  stopPlay: any = {
    status: false
  }

  reviewShow: boolean = false

  reviewId: any = ''

  classChoiceData: any = null

  choseClient: boolean = false

  finishClassVisible: boolean = false

  shutDown: boolean = false

  // 第一次进入播控页
  onceEnter: boolean = true

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  changeItem(item: any) {
    this.item = item
    if (this.item.chapterList && this.item.chapterList.length > 0) {
      this.chapter = this.item.chapterList
      this.chapterList = this.item.chapterList
    }
    this.getStatus()
  }
  isReviewNow(review: any) {
    if (!review || review.length == 0) {
      if (this.onceEnter) {
        this.classList()
      }
    } else {
      this.reviewId = review.reviewId
      localStorage.classId = review.class_id
      localStorage.clientGroupId = review.client_group_id
    }
    this.onceEnter = false
  }
  viewStudyData() {
    this.$router.push({
      name: 'study'
    })
  }
  playChange(item: any) {
    if (this.id == item.id) {
      return
    }
    this.id = item.id
    this.playChanged = true
    this.reloadPlay = false
    setTimeout(() => {
      this.reloadPlay = true
    })
  }
  finishClassClick() {
    this.finishClassVisible = true
  }
  finishClass() {
    localStorage['viewClass' + this.id] = ''
    this.$store.commit('setPlayId', '')
    this.$store.commit('setPlayInfo', null)
    this.$router.push({
      name: 'courseEdit'
    })
    this.finishCancel()
  }
  finishCancel() {
    this.finishClassVisible = false
  }

  shutDownFinish() {
    this.shutDown = true
  }
  selectChapter(value: number) {
    this.chapter = this.chapterList.filter((e: any) => {
      return e.id == value
    })
    this.getStatus()
  }

  async classList() {
    try {
      const res = await post('/api/classes/classAndClientGroup')
      const data = res.data
      if (data.go == 1) {
        this.choiceClass = true
        this.classChoiceData = data
      } else {
        this.choiceClass = false
        localStorage.classId = ''
        localStorage.clientGroupId = ''
        this.choseClient = true
      }
    } catch {}
  }

  cancelMod() {
    this.choiceClass = false
  }

  async onPlay(pause: boolean) {
    // const clientGroupId = localStorage.clientGroupId
    // if (clientGroupId) {
    //   const res = await post('/api/classes/clearClientStudent', {
    //     client_group_id: clientGroupId
    //   })
    // }
    const isPlay = this.playStatus == 'Play' || (pause && this.playStatus == 'PauseNew')
    const item = this.item
    const ids = this.$store.state.selectedDeviceIds
    const isNoOnline = this.$store.state.noOnline
    if (ids.length == 0) {
      alert(
        isNoOnline
          ? this.i18n.playCtro.noDeviceOnline
          : this.i18n.playCtro.pleaseSelectDevice,
        this.i18n.err
      )
      return
    }

    const time = localStorage.video_gettime
    const postData: any = {
      resId: this.id,
      ids
    }
    const clientGroupId = localStorage.clientGroupId
    if (clientGroupId) {
      postData.client_group_id = clientGroupId
    }
    if (item.file_type == 'video' && item.is_bokong == 1) {
      postData.time = time
    }
    if (item.file_type == 'app' && item.is_bokong == 1) {
      const chapter = this.chapter
      if (chapter != null) {
        postData.type = 'chapter'
        postData.chapterId = chapter[0].id
      }
    }
    if (item.is_review == 1) {
      const classId = localStorage.getItem('classId')
      postData.isReview = 1
      if (classId && classId.length) {
        postData.classId = classId
      } else {
        postData.classId = 0
      }
    }
    let chapterId
    if (this.chapter.length && this.chapter[0]) {
      chapterId = this.chapter[0].id
    }
    if (this.reviewId && this.reviewId != '') {
      postData.old_review_id = this.reviewId
    }
    const url = isPlay
      ? '/api/play/batchPlay_json'
      : pause
      ? '/api/play/batchPause'
      : '/api/play/batchStop_json'
    // const url = isPlay
    //   ? '/api/play/batchPlay_json'
    //   : item.file_type == 'video'
    //   ? '/api/play/batchPause'
    //   : '/api/play/batchStop_json'
    if (url == '/api/play/batchStop_json' || chapterId != 2) {
      this.stopPlay.status = true
      this.stopPlay.id = this.id
    } else {
      this.stopPlay.status = false
      this.stopPlay.id = this.id
    }
    if (chapterId == 2) {
      this.reviewShow = true
    }
    try {
      const res = await post(url, postData)
      if (res && res.data) {
        const data = res.data
        if (data.review) {
          this.$store.commit('setReviewId', data.review.reviewId)
          this.reviewId = data.review.reviewId
        }
      }
      const newStatus = isPlay
        ? pause
          ? 'Pause'
          : 'Stop'
        : pause
        ? 'PauseNew'
        : 'Play'
      if (newStatus == 'Stop' || newStatus == 'Pause') {
        const classId = localStorage.getItem('classId')
        let oldViewClass: any = {}
        if (classId) {
          oldViewClass = localStorage.getItem('viewClass' + classId)
        } else {
          oldViewClass = localStorage.getItem('viewClass')
        }
        let data: any = {}
        ids.forEach((id: any) => {
          data[id] = this.id
        })
        data = { ...JSON.parse(oldViewClass), ...data }
        if (classId) {
          localStorage.setItem('viewClass' + localStorage.classId, JSON.stringify(data))
        } else {
          localStorage.setItem('viewClass', JSON.stringify(data))
        }
      }
      this.playStatus = newStatus
      this.$store.commit('setPlayStatus', newStatus)
      const playInfo: any = {
        status: newStatus,
        id: this.id
      }
      if (item.type == 'app') {
        playInfo.chapterId = this.chapter[0].id
      }
      this.$store.commit('setPlayInfo', playInfo)
    } catch (ex) {
      alert(String(ex))
    }
  }
  checkDeviceIds() {
    const ids = this.$store.state.selectedDeviceIds || []
    const isNoOnline = this.$store.state.noOnline
    if (ids.length == 0) {
      throw new Error(
        isNoOnline
          ? this.i18n.playCtro.noDeviceOnline
          : this.i18n.playCtro.pleaseSelectDevice
      )
    }
    return ids
  }

  async syncPlayTime(ids: any, resId: any, playIsPause: boolean) {
    const time = localStorage.video_gettime
    const pdata: any = {
      resId: this.id,
      time,
      ids
    }
    playIsPause && (pdata.status = 'pause')
    await post('/api/play/sync_play_time', pdata)
  }
  // 同步画面
  async syncFrameClick() {
    try {
      const status = this.$store.state.playStatus
      const id = this.id
      const ids = this.checkDeviceIds()
      const playIsPause = status == 'Play' || status == 'PauseNew'
      await this.syncPlayTime(ids, id, playIsPause)
      message.success(this.i18n.playCtro.syncSuccess)
    } catch (ex) {
      message.error(String(ex))
    }
  }
  tabsChange(activeKey: string) {
    if (activeKey == 'class') {
      this.classActive = true
      this.installActive = false
      this.dataActive = false
    } else if (activeKey == 'install') {
      this.classActive = false
      this.installActive = true
      this.dataActive = false
    } else if (activeKey == 'play') {
      this.classActive = false
      this.installActive = false
      this.dataActive = false
      if (this.playChanged) {
        this.reloadPlay = false
        setTimeout(() => {
          this.reloadPlay = true
          this.playChanged = false
        })
      }
    } else if (activeKey == 'data') {
      this.classActive = false
      this.installActive = false
      this.dataActive = true
    }
  }
  getPlayIndex() {
    const playList = this.$store.state.playList
    let index = 0
    playList.forEach((item: any, i: number) => {
      if (item.id == this.id) {
        index = i
      }
    })
    return index
  }
  preClass() {
    const playList = this.$store.state.playList
    const index = this.getPlayIndex()
    if (index == 0) {
      message.error(this.i18n.playCtro.noPrevious)
    } else {
      const newIndex = index - 1
      this.playChange(playList[newIndex])
    }
  }
  nextClass() {
    const playList = this.$store.state.playList
    const index = this.getPlayIndex()
    const len = playList.length
    if (index + 1 == len) {
      message.error(this.i18n.playCtro.noNext)
    } else {
      const newIndex = index + 1
      this.playChange(playList[newIndex])
    }
  }
  getStatus() {
    if (this.id == this.$store.state.playInfo.id) {
      if (this.item.type != 'app') {
        this.playStatus = this.$store.state.playInfo.status
      } else {
        // app类型有多个课件
        const chapterId = this.$store.state.playInfo.chapterId || null
        if (this.chapter[0].id == chapterId) {
          this.playStatus = this.$store.state.playInfo.status
        } else {
          this.playStatus = 'Play'
        }
      }
    } else {
      this.playStatus = 'Play'
    }
  }
  onOk() {
    this.choiceClass = false
    this.choseClient = true
  }
  created() {
    this.visible = true
    this.lang = this.i18n.uHeader
    const id = this.$route.params.id
    this.id = this.$store.state.playList[0].id || id
    this.getStatus()
  }
  @Watch('$route')
  watch$route(route: any) {
    this.visible = false
  }
}
